module.exports = __webpack_public_path__ + "img/16_71.1783fb4b.png";